import { Component, OnInit } from '@angular/core';

import { RoomScanService, RoomScanSupport } from 'src/providers/room-scan/room-scan';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Util } from 'src/shared/util/util';

import { AddressModel } from 'src/models/address.model';

@Component({
    templateUrl: 'ar-room-scan.page.html',
    standalone: false
})
export class ArRoomScanPage implements OnInit {

  address: AddressModel;
  errorMessage: string;
  isScanning: boolean;
  loaded: boolean;
  scanSupport: RoomScanSupport;

  boundStartScan = this.startScan.bind(this);

  constructor(
    private navCtrl: CustomNavController,
    private roomScanService: RoomScanService,
    private util: Util
  ) {}

  async ngOnInit() {
    this.loaded = false;
    this.isScanning = false;
    this.address = this.navCtrl.getParam('address', true);
    await this.checkSupport();
    this.loaded = true;
  }

  async checkSupport() {
    this.scanSupport = await this.roomScanService.isSupported();
    console.log('[checkSupport] scanSupport:', this.scanSupport);
  }

  async startScan() {
    if (!this.scanSupport?.supported) {
      this.errorMessage = this.scanSupport?.reason || 'AR scanning is not supported on this device.';
      return;
    }

    try {
      this.isScanning = true;
      this.errorMessage = '';

      const result = await this.roomScanService.startScan();

      if (result.success) {
        const params = {
          address: this.address,
          scanResult: result
        };
        this.util.showSuccess('Room scan completed successfully!');
        this.navCtrl.navigateForward('ar-room-scan-result', params);
      } else {
        this.errorMessage = 'Scan did not complete successfully. Please try again.';
      }
    } catch (error) {
      this.errorMessage = (error as Error).message || 'An error occurred during scanning.';
    } finally {
      this.isScanning = false;
    }
  }
}
